(function() {
	'use strict';
	angular.module('masterApp').constant('MASTER_CONSTANT', {
		'typeStock' : [ {
			code : '1',
			name : 'Kho chính'
		}, {
			code : '2',
			name : 'Kho chi nhánh'
		} ],
		'dateInMonth' : [ {
			code : '1',
			name : '1'
		}, {
			code : '2',
			name : '2'
		}, {
			code : '3',
			name : '3'
		}, {
			code : '4',
			name : '4'
		}, {
			code : '5',
			name : '5'
		}, {
			code : '6',
			name : '6'
		}, {
			code : '7',
			name : '7'
		}, {
			code : '8',
			name : '8'
		}, {
			code : '9',
			name : '9'
		}, {
			code : '10',
			name : '10'
		}, {
			code : '11',
			name : '11'
		}, {
			code : '12',
			name : '12'
		}, {
			code : '13',
			name : '13'
		}, {
			code : '14',
			name : '14'
		}, {
			code : '15',
			name : '15'
		}, {
			code : '16',
			name : '16'
		}, {
			code : '17',
			name : '17'
		}, {
			code : '18',
			name : '18'
		}, {
			code : '19',
			name : '19'
		}, {
			code : '20',
			name : '20'
		}, {
			code : '21',
			name : '21'
		}, {
			code : '22',
			name : '22'
		}, {
			code : '23',
			name : '23'
		}, {
			code : '24',
			name : '24'
		}, {
			code : '25',
			name : '25'
		}, {
			code : '26',
			name : '26'
		}, {
			code : '27',
			name : '27'
		}, {
			code : '28',
			name : '28'
		}, {
			code : '29',
			name : '29'
		}, {
			code : '30',
			name : '30'
		}, {
			code : '31',
			name : '31'
		} ],
		'typeReason' : [ {
			code : 'NORMAL',
			name : 'Bình thường'
		}, {
			code : 'RETURN',
			name : 'Hoàn trả'
		}, {
			code : 'LOST',
			name : 'Mất'
		} ]
	});
})();
